import { render, staticRenderFns } from "./DiplomaStudentSave.vue?vue&type=template&id=4cb58672&"
import script from "./DiplomaStudentSave.vue?vue&type=script&lang=js&"
export * from "./DiplomaStudentSave.vue?vue&type=script&lang=js&"
import style0 from "./DiplomaStudentSave.vue?vue&type=style&index=0&id=4cb58672&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports